import { useMemo } from 'react';
import { AxiosInstance } from 'axios';
import { createHttpClient } from './httpClient';
import { getCachedClientIP } from '../fvid-auth/userSession';

// Global singleton instance - created once per session
let globalAxiosClient: AxiosInstance | null = null;

/**
 * Custom hook that provides a configured HTTP client instance
 * Returns a singleton instance shared across all components for optimal performance
 * Handles authentication, error handling, and IP address injection
 */
const useHttpClient = (): AxiosInstance => {
  const axiosClient = useMemo(() => {
    // Create singleton instance if it doesn't exist
    if (!globalAxiosClient) {
      const cachedIP = getCachedClientIP();
      globalAxiosClient = createHttpClient(cachedIP || '127.0.0.1');
    }

    return globalAxiosClient;
  }, []);

  return axiosClient;
};

export default useHttpClient;